import React from 'react';
import { Box, Typography } from '@mui/material';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';
import { adMonogram } from '../../utils/adMonogram';

interface AdAdvertiserAvatarProps {
    profilePicture: string;
    advertiserName: string;
    adTitle: string;
    themeStyle: ColorScheme;
    size?: number;
}

const AdAdvertiserAvatar: React.FC<AdAdvertiserAvatarProps> = ({
    profilePicture,
    advertiserName,
    adTitle,
    themeStyle,
    size = 30,
}) => {
    const hasProfile = typeof profilePicture === 'string' && profilePicture.trim().length > 0;
    const initials = adMonogram(advertiserName, adTitle);

    if (hasProfile) {
        return (
            <CustomLazyLoadImage
                src={profilePicture}
                alt={`${advertiserName}_profile_image`}
                style={{ width: size, height: size, borderRadius: size, objectFit: 'cover' }}
            />
        );
    }

    const fontSize = size <= 12 ? 7 : size <= 20 ? 8 : 11;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                minWidth: size,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                backgroundColor: `${theme[themeStyle].highlight}18`,
                border: `1px solid ${theme[themeStyle].highlight}50`,
            }}
            aria-label={`${advertiserName} profile`}>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize,
                    fontWeight: 700,
                    color: theme[themeStyle].highlight,
                    lineHeight: 1,
                }}>
                {initials}
            </Typography>
        </Box>
    );
};

export { AdAdvertiserAvatar };
